import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import usePageMeta from "@/hooks/usePageMeta";

export default function NotFoundPage() {
  const { t } = useTranslation();
  usePageMeta({
    title: t("notFound.title") + " — FlowGantt",
    description: t("notFound.description"),
    noindex: true,
  });
  return (
    <div className="min-h-screen grid place-items-center bg-white p-8">
      <div className="text-center max-w-md">
        <div
          data-testid="not-found-status"
          className="text-[10px] uppercase tracking-[0.3em] text-neutral-400 mb-3"
        >
          404
        </div>
        <div className="font-display text-5xl font-black tracking-tighter mb-4">
          {t("notFound.title")}
        </div>
        <p className="text-neutral-600 mb-8">{t("notFound.description")}</p>
        <Link to="/" data-testid="not-found-home-link">
          <Button className="rounded-sm bg-neutral-950 hover:bg-neutral-800 text-white h-11 px-6">
            <ArrowLeft className="w-4 h-4 mr-2" />
            {t("notFound.backHome")}
          </Button>
        </Link>
      </div>
    </div>
  );
}
